$(() => {
    if (!$('#recruit-page').length) {
        return;
    }

    $('.delete-employmentInfo-but').on('click', function() {
        return confirm('この求人情報を削除してもよろしいですか？');
    });

    $('.close-employmentInfo-but').on('click', function() {
        return confirm('この求人情報を終了してもよろしいですか？');
    });

    $('.reopen-employmentInfo-but').on('click', function() {
        return confirm('この求人情報を募集再開にしてもよろしいですか？');
    });

    $('.select2').select2({
        ajax: {
            url: '/manager/corporate/get_list',
            dataType: 'json',
            delay: 250
        },
        language: "ja",
        escapeMarkup: function (markup) {
            return markup;
        }
    });

    $('.select2').on('select2:select', function (e) {
        var data = e.params.data;
        let param = {};
        param.corporate_id = data.id;
        axios.post('/manager/facility/get_list', param)
            .then((response) => {
                let list = response.data.results;
                let options = '<option value=""></option>';
                $.each(list, function(k, item) {
                    options += '<option value="' + item.id +  '">' + item.name + '</option>';
                })
                $('#facility_id').html(options);
            }).catch(
                err => {
                    const regex = /401|403/;
                    if (err.message.match(regex)) {
                        alert('セッションが切れたため、ログイン画面へ戻ります。');
                        document.location.href = '/login';
                    } else {
                        alert(err);
                    }
                    return;
                }
            );
    });
});
